import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormGroupDirective,
  NgForm
} from '@angular/forms';
import { SelectiveProcessesPortalService } from './pages/selective-processes-portal/selective-processes-portal.service';
import { Subscription } from 'rxjs';
import { EitherValidator } from '@shared/validators/either-validator';

import { ErrorStateMatcher, MatTabGroup, MatTab } from '@angular/material';
import { ModificationAlertService } from '@shared/directives/modification-alert/modification-alert.service';
import { IFormCanDeactivate } from '@app/guards/iform-candeactivate';
import { ConfirmService } from '@shared/components/confirm/confirm.service';
import { VisualIdentityLoadPortalService } from './pages/visual-identity-portal/visual-identity-load-portal.service';
import { DomainLoadPortalService } from './pages/domain-portal/domain-load-portal.service';
import { TbcLoadPortalService } from './pages/tbc-portal/tbc-load-portal.service';
import { PortalService } from '@app/services/portal/portal.service';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from '@shared/components/loader/loader.service';
import { PreventChangeOfPortalTabService } from './prevent-change-of-portal-tab.service';
import { SelectiveEditorService } from '../selective-editor/selective-editor.service';
import { DomainPortalService } from '@app/services/portal/domain-portal/domain-portal.service';
import { NotificationService } from '@shared/components/notification/notification.service';
import { environment } from '@env';
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const controlTouched = !!(control && (control.dirty || control.touched));
    const controlInvalid = !!(control && control.invalid);
    const parentInvalid = !!(
      control &&
      control.parent &&
      control.parent.invalid &&
      (control.parent.dirty || control.parent.touched)
    );

    return controlTouched && (controlInvalid || parentInvalid);
  }
}

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss']
})
export class PortalComponent implements OnInit, OnDestroy, IFormCanDeactivate {
  public formulario: FormGroup;
  public validationDomain = true;

  public disablePS: boolean;
  public disableVI: boolean;
  public disableDO: boolean;
  public disableTBC: boolean;

  private subscriptions = new Subscription();
  public matcher = new MyErrorStateMatcher();
  public currentTabIndex: number;
  private portalId = this.getPortalId();


  @ViewChild('tabGroup', {static: true}) tabs: MatTabGroup;

  constructor(
    private modificationAlertService: ModificationAlertService,
    private formBuilder: FormBuilder,
    private sPPortalService: SelectiveProcessesPortalService,
    private serviceVisualIdentityLoadPortal: VisualIdentityLoadPortalService,
    private serviceDomainLoadPortal: DomainLoadPortalService,
    private domainPortalService: DomainPortalService,
    private serviceTBCLoadPortal: TbcLoadPortalService,
    private confirmService: ConfirmService,
    private servicePortal: PortalService,
    private selectiveEditorService: SelectiveEditorService,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private preventChangeOfPortalTabService: PreventChangeOfPortalTabService,
    private serviceNotification: NotificationService
  ) {
    this.subscriptions.add(this.sPPortalService.currentDisplay.subscribe(d => (this.disablePS = d)));
    this.subscriptions.add(this.serviceVisualIdentityLoadPortal.currentDisplay.subscribe(d => (this.disableVI = d)));
    this.subscriptions.add(this.serviceDomainLoadPortal.currentDisplay.subscribe(d => (this.disableDO = d)));
    this.subscriptions.add(this.serviceTBCLoadPortal.currentDisplay.subscribe(d => (this.disableTBC = d)));
  }

  ngOnInit(): void {
    this.formulario = this.formBuilder.group({
      geral: this.formBuilder.group({
        id: [null],
        name: [null, Validators.required],
        status: [null],
        allow_registered_alt: [false],
        days_before_evaluation: [
          { value: null, disabled: true },
          [
            Validators.required,
            Validators.min(1),
            Validators.pattern(/^[0-9]*$/)
          ]
        ],
        allow_absent_alt: [false],
        title: [null],
        title_register_portal: [],
        last_change: [null],
        changed_by: [null],
        user_details_page_id: [null],
        applyment_edit_page_id: [null],
        register_field_id: [null],
        course_field_id: [null],
        local_offer_field_id: [null],
        enable_Vlibras: [null],
        lgpd_popup_id: [null],
        log_off_link: [
          null,
          [
            Validators.pattern(
              // tslint:disable-next-line: max-line-length
              /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
            )
          ]
        ]
      }),
      identidadeVisual: this.formBuilder.group({
        id: [null],
        logo: [null],
        favicon: [null],
        institutional_color: [null, Validators.required],
        background: [null],
        header_message_active: [null],
        header_message: [null, Validators.required],
        last_change: [null],
        changed_by: [null]
      }),
      dominio: this.formBuilder.group(
        {
          id: [null],
          option_domain: ['0'],
          system_domain: [null],
          client_domain: [
            null,
            [
              Validators.pattern(
                // tslint:disable-next-line: max-line-length
                /^([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
              )
            ]
          ],
          last_change: [null],
          changed_by: [null],
          front_url: [null],
          CNAME: [null]
        },
        { validator: EitherValidator.either() }
      ),
      tbc: this.formBuilder.group({
        id: [null],
        totvs_user: [null, Validators.required],
        totvs_pass: [{ value: null, disabled: true }, Validators.required],
        tbc: [null, Validators.required],
        cod_coligate: [null, Validators.required],
        cod_system: [null, Validators.required],
        cod_user: [null, Validators.required],
        cod_affiliate: [null, Validators.required],
        cod_course_type: [null],
        use_methods_without_license: [true],
        use_methods_rest: [false],
        use_totvs_oracle: [false],
        last_change: [null],
        changed_by: [null]
      }),
      processoSeletivo: this.formBuilder.array([], Validators.required),
      portalQueries: this.formBuilder.array([], Validators.required)
    });

    this.modificationAlertService
    .getStatusAlert()
    .subscribe(arg => (this.validationDomain = arg));

    this.preventChangeOfPortalTabService.getMatTabGroup(this.tabs);
  }

  changeStatusPortal() {
    this.loaderService.setChangesLoaderState(true);
    const router: any = this.route;
    const statusBefore = this.formulario.controls.geral.value.status;
    this.servicePortal.update(router.params.value).subscribe(
      success => {
        if (success.success) {
          this.loaderService.setChangesLoaderState(false,
            `Portal foi ${statusBefore === 1 ? 'desativado' : 'ativado'} com sucesso !`,
            'ok',
            'success'
          );
          this.changeStatusForm();
        } else {
          this.loaderService.setChangesLoaderState(false,
            'Não foi possível ativar/desativar o portal, tente novamente mais tarde !',
            'ok',
            'alert');
        }
      },
      error => {
        this.loaderService.setChangesLoaderState(false,
          error.body,
          '',
          'error',
          error.title,
          100000);
      }
    );
  }

  private changeStatusForm() {
    if (this.formulario.get('geral').get('status').value === 1) {
      this.formulario.get('geral').get('status').patchValue(0, {emitEvent: false});
    } else {
      this.formulario.get('geral').get('status').patchValue(1, {emitEvent: false});
    }
  }

  restForm() {
    // tslint:disable-next-line: forin
    for (const key in this.formulario.value) {
      this.formulario.reset(this.formulario.value);
    }
  }

  tabOverflow(e) {
    const getAttribute: any = document.getElementsByClassName('ps-tab-portal');
    this.currentTabIndex = e.index;
    if (e.index === 1) {
      setTimeout(() => {
        getAttribute[0].classList.add('tab-overflow');
      }, 500);
    } else {
      getAttribute[0].classList.remove('tab-overflow');
    }
  }

  checkSave(): Promise<boolean> {
    const prom = new Promise<boolean>((resolve, reject) => {
      if (!this.preventChangeOfPortalTabService.interceptValue) {
        this.confirmService
          .openConfirm(
            'Sair da página ?',
            'As alterações feitas não serão salvas.',
            'Sair',
            'Cancelar',
            true
          )
          .afterClosed()
          .subscribe(success => {
            resolve(success);
          });
      } else {
        resolve(true);
      }
    });
    return prom;
  }

  canDisable() {
    return this.checkSave().catch(() => {
      return false;
    });
  }

  ngOnDestroy() {
    this.preventChangeOfPortalTabService.setInterceptTabChange(true)
    this.sPPortalService.changeDisplay(false);
    this.serviceVisualIdentityLoadPortal.changeDisplay(false);
    this.serviceDomainLoadPortal.changeDisplay(false);
    this.serviceTBCLoadPortal.changeDisplay(false);
    this.subscriptions.unsubscribe();
    this.selectiveEditorService.ItCameFromTheEditorSelectiveProcess =  false;
  }

  get f(): any {
    return this.formulario.controls;
  }

  public viewProcess() {
    this.getLinkPortal().then(link => {
      if (link) {
        const protocol = environment.production ? 'https://' : 'http://';
        const win = window.open(protocol + link, '_blank');
        win.focus();
      }
    });
  }

  private getLinkPortal(): Promise<any> {
    this.loaderService.setChangesLoaderState(true);
    return new Promise((resolve, reject) => {
      this.domainPortalService.read(this.portalId).subscribe(
        success => {
          const domain = success.data.option_domain === 0 ? success.data.system_domain : success.data.client_domain;
          this.loaderService.setChangesLoaderState(false);
          resolve(domain);
        },
        error => {
          this.loaderService.setChangesLoaderState(false);
          this.serviceNotification.notificationOpen(
            'Erro ao buscar dados de domínio do portal',
            'Ok',
            'error',
            100000,
            'ERROR TOTVS'
          );
          resolve(false);
        }
      );
    });
  }

  private getPortalId() {
    const router: any = this.route;
    return router.params.value.id;
  }
}
